export const TWO_COLUMNS_BETTING_TYPES = [
	"winning-margin-incl-overtime",
	"winning-margin-incl-overtime-and-penalties",
	"winning-margin-incl-extra-innings",
	"penalty-shootout-winning-margin",
	"any-team-winning-margin-incl-overtime",
	"quarternr-quarter-team-winning-margin",
	"any-team-performance-winning-margin",
	"winning-margin",
	"quarternr-quarter-winning-margin",
	"1st-half-winning-margin",
	"gamenr-game-winning-margin",
];
